module.exports = __webpack_public_path__ + "img/millfields_rd_b2.66ced9b3.jpg";